// Copyright (c) 2016 Deere & Company

import RegistrationReview from './components/registration-review';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getDateFormat} from '../../shared/services/get-date-format';
import reports from '../../routes/products/reports';

const getStateToBindToContainerProps = state => ({
    ...state.registrationReview,
    dateFormat: getDateFormat(state.user.details.settings.general.dateFormat.key),
    dealerRecommendationCount: state.dealerRecommendationsReducer.dealerRecommendations.totalElements,
    duplicatePinPlateCount: state.factoryDuplicatePinPlate.factoryDuplicatePinPlates.length,
    exportToExcel: state.exportToExcel,
    facets: {
        ...state.registrationReview.facets,
        dealerAccountsFacet: {
            ...state.registrationReview.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    },
    highRentalDaysCount: state.productSearch.highRentalDays.highdayscount,
    machineStatusUpdateCount: state.machineStatusUpdate.machineStatusUpdates.length,
    reportsRoutes: reports(),
    searchResultsCount: state.productSearch.searchResults.length,
    security: state.user.security,
    transferApprovalsCount: state.home.wip.productTracking.transferApprovals,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RegistrationReview);



// WEBPACK FOOTER //
// ./src/product/registration-review/state-connector.js